import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get inventory
export const getInventorySolarPanel = createAsyncThunk("inventory/get inventory solar panel list", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-inventorySolarPanel`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        console.log("testing invertorSolar Data", response)
        return response;
    } catch (error) {
        console.error('Error fetching inventory - ', error);
        throw error;
    }
})


